<template>
  <div>
    <slot/>
    <div class="text-center mt-3">
      <router-link to="/" class="btn btn-link p-0" v-if="!loading">
        {{ $t('components.utility.turn_back') }}
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "Utility",
  props: {
    loading: {
      default: true
    }
  }
}
</script>
